import { createContext } from "react";
import type { TopMenuContextType } from "../@types/contexts/TopMenu";

export const TopMenuContext = createContext<TopMenuContextType>({
  setTopMenuHeight: () => {},
  setTopMenuWidth: () => {},
  topMenuHeight: 0,
  topMenuWidth: 0,
});
